import { defineFetch } from 'resift';

export interface RoleCreateRequest {
  name: string;
  description?: string;
}

const makeCreateRole = defineFetch({
  displayName: 'Create Role',
  make: () => ({
    request: ({ name, description }: RoleCreateRequest) => ({ http }) =>
      http({
        method: 'POST',
        route: '/roles',
        data: { name, description },
      }),
  }),
});

const createRole = makeCreateRole();

export default createRole;
